<template>
	<button
		role="switch"
		class="toggle-switch"
		type="button"
		@click="toggleClass"
		:class="{ on: isOn, disabled: disabled }"
		:aria-checked="isOn ? 'true' : 'false'"
		:name="name"
		:value="value"
		:disabled="disabled"
	>
		<span class="on-text" aria-hidden="true">On</span>
		<span class="off-text" aria-hidden="true">Off</span>
	</button>
</template>

<script>
export default {
	name: 'ToggleSwitch',
	props: {
		value: Boolean,
		disabled: Boolean,
		name: {
			type: String,
			default: 'toggle-switch',
		},
	},
	data() {
		return {
			selected: this.value,
		};
	},
	computed: {
		isOn: {
			get() {
				return this.selected;
			},
			set(value) {
				this.selected = value;
			},
		},
	},
	methods: {
		toggleClass() {
			this.isOn = !this.isOn;
			// TODO: This should actually be emiting an input event for v-model two-way data binding
			this.$emit('click', this.isOn);
		},
	},
	watch: {
		value(newValue) {
			this.isOn = newValue;
		},
	},
};
</script>

<style lang="scss" scoped>
.toggle-switch {
	@include rem('width', 45px);
	@include rem('min-width', 45px);
	@include rem('height', 20px);
	@include rem('border-radius', 16px);
	position: relative;
	display: flex;
	border: none;
	padding: 0;
	justify-content: space-between;
	background-color: $border-color-dark;
	cursor: pointer;
	transition: $b360-motion-selection;

	&:before {
		display: inline-block;
		content: '';
		@include rem('width', 14px);
		@include rem('height', 14px);
		border-radius: 50%;
		background-color: $white;
		align-self: center;
		z-index: 3;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 6%;
		transition: left $b360-motion-duration--long $b360-motion-easing--accelerate;
	}

	.on-text,
	.off-text {
		text-transform: uppercase;
		@include typo--roboto__bold;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		color: $white;
		@include rem(font-size, 10px);
		line-height: 1;
	}

	.on-text {
		@include rem('right', 23px);
		z-index: -1;
		transition: z-index $b360-motion-duration--shortest linear;
	}

	.off-text {
		@include rem('right', 7px);
		z-index: 1;
		transition: z-index $b360-motion-duration--shortest linear;
	}

	&.on {
		background-color: $brand-teal;

		&:before {
			left: 62%;
		}

		.on-text {
			z-index: 1;
		}

		.off-text {
			z-index: -1;
		}
	}

	&.disabled {
		background-color: lighten($b360-color--gray__darker, 20%) !important;
		cursor: not-allowed;

		&:before {
			background-color: $b360-color--gray__light;
		}
	}
}
</style>
